import { combineReducers } from 'redux'
import config from './config/reducer'
import records from './records/reducer'

export default combineReducers({
  config,
  records,
})
